/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MessageTypeEnum } from './MessageTypeEnum';
import {
    MessageTypeEnumFromJSON,
    MessageTypeEnumFromJSONTyped,
    MessageTypeEnumToJSON,
    MessageTypeEnumToJSONTyped,
} from './MessageTypeEnum';

/**
 *
 * @export
 * @interface ChatMessageInput
 */
export interface ChatMessageInput {
    /**
     *
     * @type {number}
     * @memberof ChatMessageInput
     */
    chat?: number;
    /**
     *
     * @type {MessageTypeEnum}
     * @memberof ChatMessageInput
     */
    messageType: MessageTypeEnum;
    /**
     *
     * @type {string}
     * @memberof ChatMessageInput
     */
    content: string;
}



/**
 * Check if a given object implements the ChatMessageInput interface.
 */
export function instanceOfChatMessageInput(value: object): value is ChatMessageInput {
    if (!('messageType' in value) || value['messageType'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function ChatMessageInputFromJSON(json: any): ChatMessageInput {
    return ChatMessageInputFromJSONTyped(json, false);
}

export function ChatMessageInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatMessageInput {
    if (json == null) {
        return json;
    }
    return {

        'chat': json['chat'] == null ? undefined : json['chat'],
        'messageType': MessageTypeEnumFromJSON(json['message_type']),
        'content': json['content'],
    };
}

  export function ChatMessageInputToJSON(json: any): ChatMessageInput {
      return ChatMessageInputToJSONTyped(json, false);
  }

  export function ChatMessageInputToJSONTyped(value?: ChatMessageInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'chat': value['chat'],
        'message_type': MessageTypeEnumToJSON(value['messageType']),
        'content': value['content'],
    };
}
